import { CaseGranulometry } from '../../CaseGranulometry';
import { LevelGranulometry } from '../../../levels/LevelGranulometry';
import { getCaseLevels } from './getCaseLevels';
import { isGroundLevel } from '../../../levels/queries/is/isGroundLevel';

export const getCaseGroundLevel = (caseGranulometry: CaseGranulometry): LevelGranulometry =>
  getCaseLevels(caseGranulometry).filter(isGroundLevel)[0];
